import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_spring_tablescapes: FaireThemeEntity = {
  token: "discovery_theme_spring-tablescapes",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Spring Tablescapes",
  description: "Fresh table settings for the season",
  bgColor: "#D8F0D4",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
